import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { CellWithValidator, StickyHeader } from "../../../../components/Table/TableStyles";
import { offsetOneRow, offsetTwoRows, StateStyledCell } from "../../Styles/ParticipationTableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { TextFilter } from "../../../../components/Form/FormStyles";

export function CommunitySiteNameHeader() {
	return (
		<StickyHeader
			style={{
				...offsetOneRow,
				width: '320px',
				minWidth: '320px',
				maxWidth: '320px'
			}}>
			Community site name
		</StickyHeader>
	)
}

export function CommunitySiteNameFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={
						filter?.CommunitySiteNameValidated ?? ValidateFilterValue.Unset
					}
					onChange={(e) =>
						updateFilter({ ...filter, CommunitySiteNameValidated: e.value })
					}
				/>
				<TextFilter
					value={filter?.CommunitySiteName ?? ''}
					onChange={(e) =>
						updateFilter({ ...filter, CommunitySiteName: e.target.value })
					}
				/>
			</CellWithValidator>
		</StickyHeader>
	)
}

export function CommunitySiteNameContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>
					{ppn.PlantingProject.CommunitySiteNameValidated && (
						<ValidatedIcon />
					)}
				</span>
				<span>{ppn.PlantingProject.CommunitySiteName}</span>
			</CellWithValidator>
		</StateStyledCell>
	)
}